import { SelectOption } from '@kep-ui-kit/ui-components';

export const currencyOptions: SelectOption[] = [
  { text: 'AED', value: 'AED' },
  { text: 'ARS', value: 'ARS' },
  { text: 'AWG', value: 'AWG' },
  { text: 'BAM', value: 'BAM' },
  { text: 'DOP', value: 'DOP' },
  { text: 'BMD', value: 'BMD' },
  { text: 'BOB', value: 'BOB' },
  { text: 'BSD', value: 'BSD' },
  { text: 'BZD', value: 'BZD' },
  { text: 'CDF', value: 'CDF' },
  { text: 'CNY', value: 'CNY' },
  { text: 'CRC', value: 'CRC' },
  { text: 'CZK', value: 'CZK' },
  { text: 'ERN', value: 'ERN' },
  { text: 'EUR', value: 'EUR' },
  { text: 'FKP', value: 'FKP' },
  { text: 'GIP', value: 'GIP' },
  { text: 'GTQ', value: 'GTQ' },
  { text: 'HKD', value: 'HKD' },
  { text: 'HRK', value: 'HRK' },
  { text: 'IDR', value: 'IDR' },
  { text: 'INR', value: 'INR' },
  { text: 'KES', value: 'KES' },
  { text: 'KYD', value: 'KYD' },
  { text: 'LKR', value: 'LKR' },
  { text: 'MDL', value: 'MDL' },
  { text: 'MMK', value: 'MMK' },
  { text: 'MRO', value: 'MRO' },
  { text: 'MVR', value: 'MVR' },
  { text: 'MXN', value: 'MXN' },
  { text: 'MZN', value: 'MZN' },
  { text: 'NGN', value: 'NGN' },
  { text: 'NOK', value: 'NOK' },
  { text: 'NZD', value: 'NZD' },
  { text: 'PEN', value: 'PEN' },
  { text: 'PHP', value: 'PHP' },
  { text: 'PLN', value: 'PLN' },
  { text: 'RUB', value: 'RUB' },
  { text: 'SEK', value: 'SEK' },
  { text: 'SHP', value: 'SHP' },
  { text: 'SOS', value: 'SOS' },
  { text: 'STD', value: 'STD' },
  { text: 'TJS', value: 'TJS' },
  { text: 'TRY', value: 'TRY' },
  { text: 'TWD', value: 'TWD' },
  { text: 'UGX', value: 'UGX' },
  { text: 'UYU', value: 'UYU' },
  { text: 'VEF', value: 'VEF' },
  { text: 'XCD', value: 'XCD' },
  { text: 'ZMW', value: 'ZMW' },
  { text: 'XAF', value: 'XAF' },
  { text: 'CLF', value: 'CLF' },
  { text: 'ANG', value: 'ANG' },
  { text: 'SAR', value: 'SAR' },
  { text: 'KRW', value: 'KRW' },
  { text: 'MAD', value: 'MAD' },
  { text: 'BYN', value: 'BYN' },
  { text: 'BDT', value: 'BDT' },
  { text: 'GHS', value: 'GHS' },
  { text: 'VND', value: 'VND' },
  { text: 'AOA', value: 'AOA' },
  { text: 'AUD', value: 'AUD' },
  { text: 'AZN', value: 'AZN' },
  { text: 'BBD', value: 'BBD' },
  { text: 'BGN', value: 'BGN' },
  { text: 'BND', value: 'BND' },
  { text: 'BRL', value: 'BRL' },
  { text: 'BWP', value: 'BWP' },
  { text: 'CAD', value: 'CAD' },
  { text: 'CHF', value: 'CHF' },
  { text: 'COP', value: 'COP' },
  { text: 'CVE', value: 'CVE' },
  { text: 'DKK', value: 'DKK' },
  { text: 'ETB', value: 'ETB' },
  { text: 'FJD', value: 'FJD' },
  { text: 'GBP', value: 'GBP' },
  { text: 'GMD', value: 'GMD' },
  { text: 'GYD', value: 'GYD' },
  { text: 'HNL', value: 'HNL' },
  { text: 'HUF', value: 'HUF' },
  { text: 'ILS', value: 'ILS' },
  { text: 'JMD', value: 'JMD' },
  { text: 'KGS', value: 'KGS' },
  { text: 'LBP', value: 'LBP' },
  { text: 'LRD', value: 'LRD' },
  { text: 'MKD', value: 'MKD' },
  { text: 'MOP', value: 'MOP' },
  { text: 'MUR', value: 'MUR' },
  { text: 'MWK', value: 'MWK' },
  { text: 'MYR', value: 'MYR' },
  { text: 'NAD', value: 'NAD' },
  { text: 'NIO', value: 'NIO' },
  { text: 'NPR', value: 'NPR' },
  { text: 'PAB', value: 'PAB' },
  { text: 'PGK', value: 'PGK' },
  { text: 'PKR', value: 'PKR' },
  { text: 'QAR', value: 'QAR' },
  { text: 'SBD', value: 'SBD' },
  { text: 'SGD', value: 'SGD' },
  { text: 'SLL', value: 'SLL' },
  { text: 'SRD', value: 'SRD' },
  { text: 'SYP', value: 'SYP' },
  { text: 'TOP', value: 'TOP' },
  { text: 'TTD', value: 'TTD' },
  { text: 'TZS', value: 'TZS' },
  { text: 'USD', value: 'USD' },
  { text: 'UZS', value: 'UZS' },
  { text: 'WST', value: 'WST' },
  { text: 'ZAR', value: 'ZAR' },
  { text: 'ZWL', value: 'ZWL' },
  { text: 'XOF', value: 'XOF' },
  { text: 'EGP', value: 'EGP' },
  { text: 'RSD', value: 'RSD' },
  { text: 'JPY', value: 'JPY' },
  { text: 'THB', value: 'THB' },
  { text: 'RON', value: 'RON' },
  { text: 'UAH', value: 'UAH' },
  { text: 'CLP', value: 'CLP' },
  { text: 'ISK', value: 'ISK' },
];
